import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import type { AlertManager } from '@ctct/application-layer';
import type { AlertHooks, AlertPageStore } from '@ctct/state-client-layer';

import { useWidgetLifecycle } from '../../hooks/useWidgetLifecycle';

interface Props {
  initializer: Pick<AlertManager, 'alertInit'>;
  pageStore: AlertPageStore;
  hooks: AlertHooks;
}

export const useAlertWidget = ({ initializer, pageStore, hooks }: Props) => {
  const location = useLocation<{ successMessage?: string; errorMessage?: string }>();

  const componentProps = useMemo(
    () => ({
      ...initializer.alertInit({
        pageStore,
        locationState: location.state,
      }),
      hooks,
    }),
    [hooks, initializer, location.state, pageStore]
  );

  useWidgetLifecycle(componentProps.status, componentProps.lifecycle);

  return componentProps;
};

export type AlertWidgetProps = ReturnType<typeof useAlertWidget>;
